// src/services/adminService.js
import api from './api';

export const adminService = {
  // ----------------------------
  // DASHBOARD
  // ----------------------------
  getDashboardData: () => api.get('/dashboard/data').then(res => res.data),

  // ----------------------------
  // ADMINS
  // ----------------------------
  getAdmins: () => api.get('/admins').then(res => res.data),
  createAdmin: (data) => api.post('/admins', data).then(res => res.data),
  updateAdmin: (id, data) => api.put(`/admins/${id}`, data).then(res => res.data),
  deleteAdmin: (id) => api.delete(`/admins/${id}`).then(res => res.data),
  requestPasswordReset: (id) => api.post(`/admins/${id}/reset-password`).then(res => res.data),

  // ----------------------------
  // CLIENTS
  // ----------------------------
  getClients: () => api.get('/clients').then(res => res.data),
  createClient: (data) => api.post('/clients', data).then(res => res.data),
  updateClient: (id, data) => api.put(`/clients/${id}`, data).then(res => res.data),
  deleteClient: (id) => api.delete(`/clients/${id}`).then(res => res.data),

  // ----------------------------
  // PARTENAIRES
  // ----------------------------
  getPartners: () => api.get('/partners').then(res => res.data),
  createPartner: (data) => api.post('/partners', data).then(res => res.data),
  updatePartner: (id, data) => api.put(`/partners/${id}`, data).then(res => res.data),
  deletePartner: (id) => api.delete(`/partners/${id}`).then(res => res.data),

  // ----------------------------
  // PRODUITS
  // ----------------------------
  getProducts: () => api.get('/products').then(res => res.data),
  createProduct: (data) => api.post('/products', data).then(res => res.data),
  updateProduct: (id, data) => api.put(`/products/${id}`, data).then(res => res.data),
  deleteProduct: (id) => api.delete(`/products/${id}`).then(res => res.data),
  // MESSAGES DE CONTACT
  // ----------------------------
  // Appelle GET http://localhost:8080/api/contact/admin/all
  getMessages: () => api.get('/contact/admin/all').then(res => res.data),
  
  // Appelle DELETE http://localhost:8080/api/contact/admin/{id}
  deleteMessage: (id) => api.delete(`/contact/admin/${id}`).then(res => res.data),
};